const rem = {
  sm: '12px',
  md: '16px',
  xl: '18px',
  xxl: '24px',
};

export { rem };
